import partial from "lodash/partial";
import { StaticService } from "shared/services";
import { createDispatchFunction, dispatchPromise } from "shared/helpers";

// Actions
const GET_RACES_SUCCESS = "static/GET_RACES_SUCCESS";
const GET_RACES_ERROR = "static/GET_RACES_ERROR";
const GET_GENDERS_SUCCESS = "static/GET_GENDERS_SUCCESS";
const GET_GENDERS_ERROR = "static/GET_GENDERS_ERROR";
const GET_HISPANIC_SUCCESS = "static/GET_HISPANIC_SUCCESS";
const GET_HISPANIC_ERROR = "static/GET_HISPANIC_ERROR";
const GET_INSTITUTION_TYPES = "static/GET_INSTITUTION_TYPES";
const GET_SECURITY_QUESTIONS = "static/GET_SECURITY_QUESTIONS";
const GET_CAPACITY_TYPES = "static/GET_CAPACITY_TYPES";
const GET_TESTING_EVENTS = "static/GET_TESTING_EVENTS";
const GET_IRREGULARITY_CATEGORIES = "static/GET_IRREGULARITY_CATEGORIES";
const GET_IRREGULARITY_STAGES = "static/GET_IRREGULARITY_STAGES";
const GET_IRREGULARITY_TYPES = "static/GET_IRREGULARITY_TYPES";
const GET_ROLES = "static/GET_ROLES";
const GET_PERMISSIONS = "static/GET_PERMISSIONS";
const GET_ROOM_TYPES = "static/GET_ROOM_TYPES";
const GET_EMAIL_SUBJECTS = "static/GET_EMAIL_SUBJECTS";
const GET_DISPLAY_TEXTS = "static/GET_DISPLAY_TEXTS";
const GET_SERVER_DATE_TIME = "static/GET_SERVER_DATE_TIME";
const GET_ROOM_TIMING = "static/GET_ROOM_TIMING";
const GET_REG_TYPES = "static/GET_REG_TYPES";

const initialState = {
  races: [],
  roles: [],
  genders: [],
  hispanicTypes: [],
  institutionTypes: [],
  securityQuestions: [],
  capacityTypes: [],
  testingEvents: [],
  irregularityCategories: [],
  irregularityTypes: [],
  irregularityStages: [],
  permissions: [],
  roomTypes: [],
  emailSubjects: [],
  displayTexts: [],
  serverDateTime: "",
  loadingRoomTypes: false,
  regTypes: [],
};

// Reducer
export default function staticReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_RACES_SUCCESS:
      return { ...state, races: action.races };
    case GET_RACES_ERROR:
      return { ...state, error: action.error };
    case GET_GENDERS_SUCCESS:
      return { ...state, genders: action.genders };
    case GET_GENDERS_ERROR:
      return { ...state, error: action.error };
    case GET_HISPANIC_SUCCESS:
      return { ...state, hispanicTypes: action.hispanicTypes };
    case GET_INSTITUTION_TYPES:
      return { ...state, institutionTypes: action.result.data || [] };
    case GET_SECURITY_QUESTIONS:
      return { ...state, securityQuestions: action.result.data || [] };
    case GET_CAPACITY_TYPES:
      return { ...state, capacityTypes: action.result.data || [] };
    case GET_TESTING_EVENTS:
      return { ...state, testingEvents: action.result.data || [] };
    case GET_IRREGULARITY_CATEGORIES:
      return { ...state, irregularityCategories: action.result.data || [] };
    case GET_IRREGULARITY_TYPES:
      return { ...state, irregularityTypes: action.result.data || [] };
    case GET_IRREGULARITY_STAGES:
      return { ...state, irregularityStages: action.result.data || [] };
    case GET_ROLES:
      return { ...state, roles: action.result.data || [] };
    case GET_PERMISSIONS:
      return {
        ...state,
        permissions: action.result.data || [],
      };
    case GET_ROOM_TYPES:
      return {
        ...state,
        roomTypes: action.result.data?.data || [],
        loadingRoomTypes: action.result.loading,
      };
    case GET_EMAIL_SUBJECTS:
      return {
        ...state,
        emailSubjects: action.result.data || [],
      };
    case GET_DISPLAY_TEXTS:
      return { ...state, displayTexts: action.result.data || [] };
    case GET_SERVER_DATE_TIME:
      return { ...state, serverDateTime: action.result.data || "" };
    case GET_ROOM_TIMING:
      const mappedRoomTiming = action.result.data?.data.map((item) => ({
        code: item.code,
        value: {
          id: item.id,
          name: item.name,
          displayOrder: item.displayOrder,
        },
      }));
      return {
        ...state,
        roomTiming: action.result.data?.data || [],
        mappedRoomTiming: mappedRoomTiming
          ? Object.assign(
              {},
              ...mappedRoomTiming.map((item) => ({ [item.code]: item.value }))
            )
          : {},
      };
    case GET_REG_TYPES:
      return { ...state, regTypes: action.result.data?.data || [] };
    default:
      return state;
  }
}

// Action creators
export function getRacesSuccess(races) {
  return { type: GET_RACES_SUCCESS, races };
}

export function getRacesError(error) {
  return { type: GET_RACES_ERROR, error };
}

export function getGendersSuccess(genders) {
  return { type: GET_GENDERS_SUCCESS, genders };
}

export function getGendersError(error) {
  return { type: GET_GENDERS_ERROR, error };
}

export function getHispanicTypesSuccess(hispanicTypes) {
  return { type: GET_HISPANIC_SUCCESS, hispanicTypes };
}

export function getInstitutionTypesAction(result) {
  return { type: GET_INSTITUTION_TYPES, result };
}

export function getSecurityQuestionsAction(result) {
  return { type: GET_SECURITY_QUESTIONS, result };
}

export function getCapacityTypesAction(result) {
  return { type: GET_CAPACITY_TYPES, result };
}

export function getTestingEventsAction(result) {
  return { type: GET_TESTING_EVENTS, result };
}

export function getIrregularityCategoriesAction(result) {
  return { type: GET_IRREGULARITY_CATEGORIES, result };
}

export function getIrregularityTypesAction(result) {
  return { type: GET_IRREGULARITY_TYPES, result };
}

export function getIrregularityStagesAction(result) {
  return { type: GET_IRREGULARITY_STAGES, result };
}

export function getRolesAction(result) {
  return { type: GET_ROLES, result };
}

export function getPermissionsAction(result) {
  return { type: GET_PERMISSIONS, result };
}

export function getRoomTypesAction(result) {
  return { type: GET_ROOM_TYPES, result };
}

export function getEmailSubjectsAction(result) {
  return { type: GET_EMAIL_SUBJECTS, result };
}

export function getDisplayTextsAction(result) {
  return { type: GET_DISPLAY_TEXTS, result };
}

export function getServerDateTimeAction(result) {
  return { type: GET_SERVER_DATE_TIME, result };
}

export function getRoomTimingAction(result) {
  return { type: GET_ROOM_TIMING, result };
}

export function getRegTypesAction(result) {
  return { type: GET_REG_TYPES, result };
}

//  Action dispatchers
export function getRaces() {
  return function (dispatch) {
    return StaticService.getRaces()
      .then((response) => {
        dispatch(getRacesSuccess(response));
      })
      .catch((error) => {
        dispatch(getRacesError(error.data));
      });
  };
}

export function getGenders() {
  return function (dispatch) {
    return StaticService.getGenders()
      .then((response) => {
        dispatch(getGendersSuccess(response));
      })
      .catch((error) => {
        dispatch(getGendersError(error.data));
      });
  };
}

export function getHispanicTypes() {
  return function (dispatch) {
    return StaticService.getHispanicTypes()
      .then((response) => {
        dispatch(getHispanicTypesSuccess(response));
      })
      .catch((error) => {
        dispatch(getGendersError(error.data));
      });
  };
}

export function getInstitutionTypes() {
  return createDispatchFunction(
    partial(StaticService.getInstitutionTypes),
    getInstitutionTypesAction
  );
}

export function getSecurityQuestions() {
  return createDispatchFunction(
    partial(StaticService.getSecurityQuestions),
    getSecurityQuestionsAction
  );
}

export function getCapacityTypes(cycleId) {
  return createDispatchFunction(
    partial(StaticService.getCapacityTypes, cycleId),
    getCapacityTypesAction
  );
}

export function getTestingEvents() {
  return createDispatchFunction(
    partial(StaticService.getTestingEvents),
    getTestingEventsAction
  );
}

export function getIrregularityCategories() {
  return createDispatchFunction(
    partial(StaticService.getIrregularityCategories),
    getIrregularityCategoriesAction
  );
}

export function getIrregularityTypes(params) {
  return createDispatchFunction(
    partial(StaticService.getIrregularityTypes, params),
    getIrregularityTypesAction
  );
}

export function getIrregularityStages(params) {
  return createDispatchFunction(
    partial(StaticService.getIrregularityStages, params),
    getIrregularityStagesAction
  );
}

export function getRoles() {
  return createDispatchFunction(
    partial(StaticService.getRoles),
    getRolesAction
  );
}

export function getPermissions() {
  return createDispatchFunction(
    partial(StaticService.getPermissions),
    getPermissionsAction
  );
}

export function getRoomTypes(cycleId) {
  return (dispatch, getState) => {
    const { roomTypes } = getState().statics;
    if (roomTypes.length && roomTypes[0].cycleId === cycleId) {
      return dispatch(getRoomTypesAction({ data: roomTypes }));
    }
    return dispatchPromise(
      dispatch,
      partial(StaticService.getRoomTypes, cycleId),
      getRoomTypesAction
    );
  };
  // return createDispatchFunction(
  //   partial(StaticService.getRoomTypes, cycleId),
  //   getRoomTypesAction
  // );
}

export function getEmailSubjects() {
  return createDispatchFunction(
    partial(StaticService.getEmailSubjects),
    getEmailSubjectsAction
  );
}

export function getDisplayTexts(cycleId) {
  return createDispatchFunction(
    partial(StaticService.getDisplayTexts, cycleId),
    getDisplayTextsAction
  );
}

export function getServerDateTime() {
  return createDispatchFunction(
    partial(StaticService.getServerDateTime),
    getServerDateTimeAction
  );
}

export function getRoomTiming() {
  return createDispatchFunction(
    partial(StaticService.getRoomTiming),
    getRoomTimingAction
  );
}

export function getRegTypes(cycleId) {
  return createDispatchFunction(
    partial(StaticService.getRegTypes, cycleId),
    getRegTypesAction
  );
}
